export default __webpack_public_path__ + "static/media/logo1.3e907c44.PNG";